import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { layout } from '../styles';
export var StyledCopyLink = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n\tdisplay: flex;\n"])), layout.smallSpace);
export var StyledCopyLinkInput = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n\tflex-grow: 1;\n"])), layout.smallSpace);